import {
  formatLabelByCampaignType,
  formatLabelByPromotionType
} from '@library/utils/promotions';
import { PageTitle } from '@library/components/PageTitle';
import { PromotionFormSwitch } from '@bo-components/promotions/PromotionFormSwitch';
import { useSearchParams } from 'react-router-dom';

export const CreatePromotionEntry = () => {
  const [searchParams] = useSearchParams();
  const currentPromoType = searchParams.get('type');
  const campaignType = searchParams.get('campaign') ?? '';
  const title = `Create ${formatLabelByCampaignType(campaignType)} Promotion`;
  const subtitle = currentPromoType
    ? formatLabelByPromotionType(currentPromoType)
    : 'Choose Promotion Type';

  return (
    <div className="flex w-auto max-w-4xl flex-col px-6 pb-2 pt-3">
      <PageTitle title={title} subtitle={subtitle} />
      <PromotionFormSwitch />
    </div>
  );
};
